import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '@/components/layout/PageHeader'
import { Breadcrumb } from '@/components/layout/Breadcrumb'
import { Button } from '@/components/ui/Button'
import { PageError } from '@/components/ui/PageAsyncState'
import { FormField } from '@/components/forms/FormField'
import { demandService } from '@/services/demand'

const inputClass =
  'w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] bg-white px-2.5 py-1.5 text-sm outline-none focus:border-[var(--color-accent)]'

export function DemandFormPage() {
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [notes, setNotes] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setSaving(true)
    try {
      const created = await demandService.create({
        title: title.trim(),
        notes: notes.trim() || null,
      })
      navigate(`/purchasing/demand/${created.id}`)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Không thể tạo đợt')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <Breadcrumb
        items={[
          { label: 'Trang chủ', to: '/' },
          { label: 'Mua hàng', to: '/purchasing' },
          { label: 'Nhu cầu (Demand)', to: '/purchasing/demand' },
          { label: 'Đợt mới' },
        ]}
      />
      <PageHeader title="Tạo đợt nhu cầu" subtitle="Không hardcode người tạo" />
      <form
        onSubmit={(e) => void handleSubmit(e)}
        className="max-w-2xl space-y-3"
      >
        {error ? <PageError message={error} /> : null}
        <section className="border border-[var(--color-border)] bg-white">
          <div className="border-b border-[var(--color-border)] bg-slate-50 px-3 py-2 text-xs font-semibold tracking-wide text-slate-600 uppercase">
            Thông tin đợt
          </div>
          <div className="grid grid-cols-1 gap-3 p-3 sm:grid-cols-2 sm:p-4">
            <FormField label="Tiêu đề" required>
              <input
                required
                className={inputClass}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Tháng 9 / Đợt SX…"
              />
            </FormField>
            <FormField label="Ghi chú">
              <textarea
                className={inputClass}
                rows={3}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </FormField>
          </div>
        </section>
        <div className="flex justify-end gap-2 border border-[var(--color-border)] bg-slate-50 px-3 py-2.5">
          <Button
            type="button"
            variant="secondary"
            onClick={() => navigate('/purchasing/demand')}
            disabled={saving}
          >
            Hủy
          </Button>
          <Button type="submit" disabled={saving}>
            {saving ? 'Đang lưu…' : 'Tạo đợt'}
          </Button>
        </div>
      </form>
    </div>
  )
}
